import { render, staticRenderFns } from "./CustomVuetablePagination.vue?vue&type=template&id=5d260dc8&scoped=true&"
import script from "./CustomVuetablePagination.vue?vue&type=script&lang=js&"
export * from "./CustomVuetablePagination.vue?vue&type=script&lang=js&"
import style0 from "./CustomVuetablePagination.vue?vue&type=style&index=0&id=5d260dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d260dc8",
  null
  
)

export default component.exports